import { ReactComponent as LeftArrow } from 'images/leftArrow.svg';
import { useStores } from 'index';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { BackButton, ControlsWrapper, TeamLabel, TeamsWrapper, TeamValue } from './ControlsStyles';

export const Controls = () => {
  const history = useHistory();
  const gameStore = useStores().gameStore;

  return (
    <ControlsWrapper>
      <BackButton onClick={() => history.push('/')} data-testid='back-button'>
        <LeftArrow />
      </BackButton>
      <TeamsWrapper>
        <div>
          <TeamLabel>Home team</TeamLabel>
          <TeamValue>{gameStore.game.homeTeam}</TeamValue>
        </div>
        <TeamValue>vs.</TeamValue>
        <div>
          <TeamLabel>Away team</TeamLabel>
          <TeamValue>{gameStore.game.awayTeam}</TeamValue>
        </div>
      </TeamsWrapper>
    </ControlsWrapper>
  );
};
